import bankPicker from './components/bankPicker'
import submitNotification from './components/submitNotification'
import giftCardDialog from '@/store/modules/components/giftCardDialog'
export default {
  namespaced: true,
  modules: {
    bankPicker,
    submitNotification,
    giftCardDialog,
  },
}
